import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import FileLink from 'src/assets/images/FileLink.svg';
import { PoText, PoValue } from './reportPayment.styled';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import styled from 'styled-components';
import { getPoImagePreview } from 'src/pages/reportUsage/redux/action/actionCreators';
import PoImagePreview from './AddPo/PoImagePreview';
import media from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';


const PoInfoView = ({ item, fileName, poInfoPaddingLeft }) => {
    const { t } = useTranslation();
    const { payment } = item;
    const [previewImage, setPreviewImage] = useState(false);
    const dispatch = useDispatch();
    const openImagePreview = (fileName) => {
        if (fileName) {
            const object = {
                fileName,
            };
            dispatch(getPoImagePreview(object));
            setPreviewImage(true);
        }
    };

    return (
        <>
            {item.isPoImageError ? (
                <AlertTextDiv>
                    <AlertMsg message={item.poImageErrorMsg} />
                </AlertTextDiv>
            ) : null}

            <MainContainer
                alignItems={payment?.poAttachment && 'flex-start'}
                poInfoPaddingLeft={poInfoPaddingLeft}
            >
                <>
                    {payment?.poAttachment ? (
                        <FileLinkImage
                            id={`reportUsage-reportpayment-po-file-link-image-${fileName}`}
                            onClick={() => openImagePreview(fileName)}
                            src={FileLink}
                        />
                    ) : null}
                </>

                {payment?.poNumber ? (
                    <POInfoContainer
                        onClick={() => openImagePreview(fileName)}
                        isAttachmentPresent={payment?.poAttachment}
                    >
                        <PoText fontFamily={'AvenirNextWorld Demi'}>
                            {t('consignmentReturn.submit.po')}
                       </PoText> 
                        <PoValue className="report-payment-po-number-dt-mask" wordBreak={'break-word'}>
                            {payment?.poNumber}
                        </PoValue>
                    </POInfoContainer>
                ) : null}
                {previewImage && (
                    <PoImagePreview
                        closePoImagePreview={(e) => {
                            setPreviewImage(false);
                            e.stopPropagation();
                        }}
                    />
                )}
            </MainContainer>
        </>
    );
};

export default PoInfoView;

const AlertTextDiv = styled.div`
    display: flex;
    align-items: center;
    ${media.mobileDevice`
        align-items: flex-start;
        margin-left: 0px;
    `};
    ${media.smalDevice`
        align-items: flex-start;
        margin-left: 0px;
    `};
`;
const MainContainer = styled.div`
    margin-left: ${({ marginLeft }) => marginLeft};
    display: flex;
    align-items: ${({ alignItems }) => (alignItems ? alignItems : 'center')};
    padding-left: ${(props) => props.poInfoPaddingLeft};
    ${media.mobileDevice`
        align-items: flex-start;
        margin-left: 0px;
    `};
    ${media.smalDevice`
        align-items: flex-start;
        margin-left: 0px;
    `};
`;
const FileLinkImage = styled.img.attrs((props) => ({
    src: props.src,
}))`
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin-right: 2px;
`;
const POInfoContainer = styled.div`
    display: flex;
    cursor: ${(props) => (props.isAttachmentPresent ? 'pointer' : 'unset')};
`;
